@if(loader) {
<app-loader></app-loader>
}

<p-card [header]="isEditMode ? 'Update Request for Quote' : 'Create Request for Quote'">
  <form [formGroup]="RfqDetailsForm">
    <div class="field col-12 flex justify-content-between align-items-center">

      <div class="flex">
        <p-button [label]="isEditMode ? 'Update' : 'Save'" icon="pi pi-save" size="small"
          (click)="saveRfq(RfqDetailsForm.value, isEditMode)">
        </p-button>

        <p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger" size="small"
          (click)="cancel()">
        </p-button>
      </div>

      <div>
        <label class="block label-required" style="font-weight: bold;">
          Required Field
        </label>
      </div>

    </div>


    <div class="grid mt-3">
      <div class="col">
        <div class="field text-left">
          <label for="rfqCode" class="label-required display">RFQ Code</label>
          <div style="display: flex; align-items: center;">
            <input type="text" pInputText placeholder="e.g R89098" (keydown)="onKeydown($event)"
              (blur)="checkVendorCode()" [readonly]="isEditMode || isManual || Rfq.length > 0"
              class="w-full p-inputtext-sm" formControlName="rfqCode"
              [ngClass]="{ 'ng-invalid ng-dirty':  submitted && formControls.rfqCode.errors }" />
            @if (!isEditMode) {
            <div style="margin-left: 10px;">
              <p-checkbox formControlName="manualEntry" *ngIf="Rfq.length == 0" (onChange)="manualEntry()"
                [binary]="true" label="Manual Entry" value="true"></p-checkbox>
            </div>
            }
          </div>
        </div>

        <div class="field text-left">
          <label for="rfqName" class="label-required display">RFQ Name</label>
          <input pInputText placeholder="e.g Tom Hank" (keydown)="onKeydown($event)" class="w-full p-inputtext-sm"
            formControlName="rfqName" [ngClass]="{ 'ng-invalid ng-dirty': submitted && formControls.rfqName.errors }" />
        </div>
      </div>

      <div class="col">
        <div class="field text-left">
          <label for="warehouse" class="label-required display">{{unitLabel}}</label>
          <p-autoComplete formControlName="warehouse" [dropdown]="product.length > 0 ? false : true" [forceSelection]="true"
            [readonly]="product.length > 0" (onSelect)="setWarehouse($event)" [suggestions]="filterWarehouses"
            (completeMethod)="filterWarehouse($event)" field="warehouseName" placeholder="Search {{unitLabel}}"
            styleClass="w-full" [ngClass]="{'ng-invalid ng-dirty':submitted && formControls.warehouse.errors}"
            (keydown.enter)="focusNextInput($event)">
            <ng-template let-item pTemplate="item">
              <span>{{ item.warehouseCode }} - {{ item.warehouseName }}</span>
            </ng-template>
          </p-autoComplete>
        </div>
        <div class="field text-left mt-5">
          <label for="rfqDate" class="label-required display">RFQ Date</label>
          <p-calendar formControlName="rfqDate" [showIcon]="true" placeholder="Select Date" class="w-full"
            dateFormat="dd/mm/yy" [ngClass]="{ 'ng-invalid ng-dirty': submitted && formControls.rfqDate.errors }">
          </p-calendar>
        </div>

      </div>
    </div>

    <p-tabView>
      <p-tabPanel header="Vendor List">
        <p-table #vendorTable [value]="Vendors" [totalRecords]="Vendors.length" responsiveLayout="scroll"
          class="w-full m-3" styleClass="p-datatable-sm" [paginator]="true" [rows]="10"
          [rowsPerPageOptions]="[10,15,20]" [(selection)]="selectedVendor">
          <ng-template pTemplate="header">
            <tr>
              <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
              <th>Sr No</th>
              <th>Vendor Code</th>
              <th>Vendor</th>
              <th>Address</th>
              <th>Phone / Email</th>
              <th>Enter Prices</th>
              <th>Print</th>
              <th>Delete</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-vendor let-i="rowIndex">
            <tr>
              <td><p-tableCheckbox [value]="vendor"></p-tableCheckbox></td>
              <td>{{ i + 1 }}</td>
              <td>{{ vendor.vendorCode }}</td>
              <td>{{ vendor.vendorName }}</td>
              <td>{{ vendor.address?.addressLine1 }}</td>
              <td>{{ vendor.mobile || vendor.phone }} / {{ vendor.email }}</td>
              <td>
                <button type="button" class="p-button p-button-sm p-button-rounded"
                  (click)="openProductPriceLookup(vendor)" pTooltip="Enter Prices" tooltipPosition="top"
                  style="display: flex; align-items: center; gap: 4px;">
                  <i class="pi pi-file-edit"></i>
                </button>
              </td>
              <td><span class="pi pi-print" style="color: rgb(0 35 255); cursor: pointer;"
                  (click)="showReport()"></span></td>
              <td>
                <button type="button" class="p-button p-button-danger p-button-sm p-button-rounded"
                  (click)="deleteVendor(vendor)" pTooltip="Delete Vendor" tooltipPosition="top">
                  <i class="pi pi-trash"></i>
                </button>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="footer">
            <tr>
              <td colspan="7">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <p-autoComplete formControlName="vendorName" [readonly]="product.length > 0"
                    (onSelect)="setVendor($event)" [suggestions]="VendorList"
                    (completeMethod)="autosearchVendor($event)" field="vendorName" placeholder="Search Vendor"
                    [appendTo]="'body'"
                    [ngClass]="{ 'ng-invalid ng-dirty': submitted && formControls.vendorCode.errors }"
                    (keydown.enter)="focusNextInput($event)">
                    <ng-template let-item pTemplate="item">
                      <span>{{ item.vendorCode }} - {{ item.vendorName }}</span>
                    </ng-template>
                  </p-autoComplete>
                  <p-button type="button" icon="pi pi-search" [disabled]="product.length > 0"
                    styleClass="p-button-sm p-button-info" (click)="getVendor()"></p-button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>

      <p-tabPanel header="Product List" [disabled]="Vendors.length === 0">
        <p-table #productTable [value]="Products" responsiveLayout="scroll" class="w-full m-3"
          styleClass="p-datatable-sm" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,15,20]"
          [(selection)]="selectedVendor">
          <ng-template pTemplate="header">
            <tr>
              <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
              <th>Sr No</th>
              <th>Product Code</th>
              <th>Product Name</th>
              <th>UOM</th>
              <th>Price</th>
              <th class="label-required display">Qty</th>
              <th class="label-required display">Date Required</th>
              <th>Remark</th>
              <th>Delete</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-product let-i="rowIndex">
            <tr>
              <td><p-tableCheckbox [value]="product"></p-tableCheckbox></td>
              <td>{{ i + 1 }}</td>
              <td>{{ product.productCode }}</td>
              <td>{{ product.productName }}</td>
              <td>{{ product.unitsOfMeasure }}</td>
              <td>
                <input type="number" pInputText [(ngModel)]="product.salesPrice"
                  name="salesPrice_{{product.productCode}}" [ngModelOptions]="{ standalone: true }" style="width: 80px;"
                  (ngModelChange)="onProductPriceChange(product)"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !product.salesPrice }" />
              </td>
              <td>
                <input type="number" pInputText [(ngModel)]="product.qty" name="qty_{{product.productCode}}"
                  [ngModelOptions]="{ standalone: true }" style="width: 80px;"
                  (ngModelChange)="onProductQtyChange(product)"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !product.qty }" styleClass="w-full" />
              </td>
              <td>
                <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" [(ngModel)]="product.requiredDate"
                  [ngModelOptions]="{ standalone: true }" [showIcon]="true" placeholder="Select Date"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !product.requiredDate }" styleClass="w-full"
                  (ngModelChange)="onProductDateChange(product)" appendTo="body">
                </p-calendar>
              </td>
              <td><span class="text-lg cursor-pointer" (click)="showComment(product)"><i
                    class="pi pi-comment"></i></span></td>
              <td>
                <button type="button" class="p-button p-button-danger p-button-sm p-button-rounded"
                  (click)="deleteProduct(product)" pTooltip="Delete Product" tooltipPosition="top">
                  <i class="pi pi-trash"></i>
                </button>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="footer">
            <tr>
              <td colspan="8">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <p-autoComplete formControlName="productCode" (onSelect)="setProduct($event)"
                    [suggestions]="filterProductList" (completeMethod)="autosearchProduct($event)" field="customerCode"
                    [appendTo]="'body'" [forceSelection]="true" placeholder="Search Product">
                    <ng-template let-item pTemplate="item">
                      <span>{{ item.productCode }} - {{ item.productName }}</span>
                    </ng-template>
                  </p-autoComplete>
                  <p-button icon="pi pi-search" styleClass="p-button-sm p-button-info"
                    (click)="getProduct()"></p-button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
    </p-tabView>
  </form>
</p-card>
<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>